import CodeError from './CodeError';

class InvalidConfirmationCodeError extends CodeError {
  constructor() {
    const code = 'invalidConfirmationCode';
    const message = 'Invalid confirmation code';
    super(code, message);
    if ('function' === typeof Error.captureStackTrace) {
      Error.captureStackTrace(this, this.constructor);
    } else {
      this.stack = (new Error(message)).stack;
    }
  }
}

export default InvalidConfirmationCodeError;
